import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [
  { to: "/hotels/udaipur", label: "The Ananta Udaipur" },
  { to: "/destinations", label: "Destinations" },
  { to: "/gallery", label: "Gallery" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
  { to: "/manage-booking", label: "Manage Booking" },
];

export const Wordmark = ({ light }) => (
  <Link to="/" data-testid="header-logo" className="flex items-center" aria-label="The Ananta Hotels home">
    <img src="/images/brandlogo-lg.png" alt="The Ananta Hotels" width="180" height="55"
      className={`h-10 sm:h-12 w-auto transition-[filter] duration-500 ${light ? "brightness-0 invert" : ""}`} />
  </Link>
);

export default function Header() {
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const overHero = pathname === "/" || pathname.startsWith("/hotels/");
  const light = overHero && !scrolled && !open;

  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 40);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header className={`${overHero ? "fixed" : "sticky"} top-0 inset-x-0 z-40 transition-[background-color,box-shadow] duration-500 ${light ? "bg-transparent" : "bg-[#FDFBF7]/85 backdrop-blur-xl border-b border-[#E2DCD0]/70 shadow-sm"}`}>
      <div className="container-x flex h-[72px] items-center justify-between">
        <Wordmark light={light} />
        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} data-testid={`nav-${n.to.replace(/\//g, "-").slice(1)}`}
              className={({ isActive }) => `text-[12px] uppercase tracking-[0.18em] transition-opacity hover:opacity-100 ${light ? "text-[#FDFBF7]" : "text-[#1A1A1A]"} ${isActive ? "opacity-100" : "opacity-75"}`}>
              {n.label}
            </NavLink>
          ))}
          <Link to="/book" data-testid="header-book-now-btn" className={light ? "btn-gold" : "btn-primary"}>Book Now</Link>
        </nav>
        <div className="flex items-center gap-3 lg:hidden">
          <Link to="/book" data-testid="header-book-now-mobile-btn" className="btn-gold !h-10 !px-4">Book</Link>
          <button aria-label="Menu" data-testid="mobile-menu-toggle" onClick={() => setOpen(!open)} className={light ? "text-white" : "text-[#1E3B2E]"}>
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>
      {open && (
        <nav data-testid="mobile-menu" className="lg:hidden bg-[#FDFBF7] border-t border-[#E2DCD0] px-5 pb-6">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} data-testid={`mobile-nav-${n.to.replace(/\//g, "-").slice(1)}`} className="block py-4 border-b border-[#E2DCD0] font-['Cormorant_Garamond'] text-2xl text-[#1E3B2E]">
              {n.label}
            </Link>
          ))}
        </nav>
      )}
    </header>
  );
}
